import { useState, useEffect } from 'react'; // Dodat useEffect
import { useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Icon from '../../components/AppIcon';
import LoginModal from '../../components/navigation/LoginModal';
import HeroSection from './components/HeroSection';
import ForgotPasswordModal from '../../components/navigation/ForgotPasswordModal';

const LoginPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  
  // 1. Postavljamo isModalOpen na true odmah u startu
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [isForgotOpen, setIsForgotOpen] = useState(false);
  const [modalMode, setModalMode] = useState('login');

  // 2. Osiguravamo da se modal aktivira pri mount-ovanju (za svaki slučaj)
  useEffect(() => {
    setIsModalOpen(true);
  }, []);

  const handleOpenModal = (mode) => {
    setModalMode(mode);
    setIsModalOpen(true);
    setIsForgotOpen(false);
  };

  const handleCloseModal = () => {
    // Ako je ovo namjenska Login stranica, možda ne želiš da korisnik uopšte zatvori modal?
    // Ako želiš da ostane otvoren, možeš ostaviti prazno ili navigate nazad
    setIsModalOpen(false);
  };

  const handleOpenForgot = () => {
    setIsModalOpen(false);
    setIsForgotOpen(true);
  };

  const handleAuthSuccess = (data) => {
    setIsAuthenticated(true);
    const korisnikRuolo = data.ruolo; 


    setTimeout(() => {
      switch (korisnikRuolo) {
        case 'superAdmin':
           case 'Admin':
          navigate('/admin-menu-page');
          break;
        case 'Owner':
       
          navigate('/home-dashboard-owner');
          break;

             case 'cco-admin':
          navigate('/acv-home'); 
          break;

             case 'cco-utente':
          navigate('/acv-home'); 
          break;
          
        case 'User':
          navigate('/home-dashboard-dipendente'); 
          break;
        case 'qrScanner':
          navigate('/qr-code-reader'); 
          break;
        default:
          navigate('/home-dashboard-dipendente');
          break;
      }
    }, 300);
  };

  return (
    <>
      <Helmet>
        <title>{t('landing.seo_title')}</title>
        <meta name="description" content={t('landing.seo_description')} />
      </Helmet>

      <div className="min-h-screen bg-background">
        {/* Dugme za nazad */}
        <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-8 pt-24">
            <button 
              onClick={() => navigate('/')} 
              className="group inline-flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors font-bold uppercase text-[10px] tracking-widest"
            >
              <div className="p-2 bg-muted group-hover:bg-primary/10 transition-colors rounded-xl">
                <Icon name="ArrowLeft" size={16} />
              </div>
              {t('profile_page.back')}
            </button>
        </div>

        <main role="main" className="w-full">
          <HeroSection 
            onLoginClick={() => handleOpenModal('login')}
            onRegisterClick={() => handleOpenModal('register')}
          />
        </main>

         {/* Mminimalistički Footer - Samo OrizonDesk */}
        <footer className="w-full py-6 border-t border-border bg-card">
          <div className="max-w-6xl mx-auto px-4 text-center">
            <p className="text-sm text-muted-foreground">
              © {new Date()?.getFullYear()} OrizonDesk
            </p>
          </div>
        </footer>

        {/* MODALI - Login se otvara odmah zbog initial state-a */}
        <LoginModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onSuccess={handleAuthSuccess}
          onForgotPassword={handleOpenForgot}
        />

        <ForgotPasswordModal 
          isOpen={isForgotOpen} 
          onClose={() => setIsForgotOpen(false)} 
          onBackToLogin={() => {
            setIsForgotOpen(false);
            setIsModalOpen(true);
          }}
        />
      </div>
    </>
  );
};

export default LoginPage;